import getSetor from "@/utils/getSetor";
import { CardEquipe } from "./CardEquipe";
import moment from "moment";

export function Equipe({ data = [], unidadeId }) {
  return (
    <div className="grid grid-cols-4 gap-4">

      {data.map(item => (
        <CardEquipe
          key={item.setor}
          setor={getSetor(item.setor)}
          solicitacoes={item.solicitacoes}
          total_finalizados={item.total_finalizados}
          total_andamento={item.solicitacoes.length}
          ultimo_registro={item.ultimo_registro ? moment(item.ultimo_registro).format('DD/MM/YY HH:mm') : null}
          unidadeId={unidadeId}
        />
      ))}

    </div>
  )
}